module.exports = __webpack_public_path__ + "static/media/imagen1.75505e82.jpg";